/**
 * Telling teams apart (workbench D239). A team's name is shown beside a record only when the
 * project the records belong to has more than one team, and then as a quiet word in the row's
 * secondary line, never a badge on every row. The platform does not count a project's teams
 * with a call of its own: the records a view already holds say how many are at work.
 */
/** The team on a decision record's memory tag `team:<id>[|<name>]`, as the workbench writes it. */
export function teamOfTags(tags) {
    const tag = (tags ?? []).find((t) => typeof t === "string" && t.startsWith("team:"));
    if (!tag)
        return undefined;
    const [id, name] = tag.slice("team:".length).split("|");
    return id ? { id, ...(name ? { name } : {}) } : undefined;
}
/** Whether the records name more than one team: the ids (or names, for a record that has only a name) of the teams that raised them. */
export function hasManyTeams(teams) {
    const seen = new Set();
    for (const t of teams)
        if (t)
            seen.add(t);
    return seen.size > 1;
}
/** A team's name for people: its name when it has one, else its id. */
export const teamWord = (t) => t?.name || t?.id || undefined;
//# sourceMappingURL=teamsTold.js.map